<template>
  <div class="bg-white" :class="isMobile && '-mx-16 -my-4 -mb-[20vh]'">
    <div class="bg-gradient-to-b from-[#94C2FF] via-white to-white">
      <TheHeader
        v-if="!isMobile"
        brandTitle="TripMentor"
        class="!bg-transparent md:z-10"
      />
      <section
        class="relative z-0 px-20 py-0 md:-mt-[103px] md:pt-[12.5rem] lg:pb-[12.5rem] xl:px-0"
      >
        <!-- BACKGROUND IMAGE -->
        <CloudsSVG
          class="absolute inset-x-0 top-0 -z-10 w-full object-cover"
          draggable="false"
          alt="background"
        />

        <img
          v-if="isMobile"
          src="@/assets/svg/500-bg.svg?url"
          alt="404"
          draggable="false"
          class="bg-image bg-image--mobile"
        />

        <div v-else class="py-60 text-center">
          <ServerError class="mx-auto mb-28 block" />

          <p class="text-subject">
            {{ $t('serverErrorPage.description') }}
          </p>
        </div>
      </section>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useHead } from '@unhead/vue'
import { useDevicePlatform } from '../composables'
import TheHeader from '@/modules/Core/components/layout/Header/TheHeader.vue'
import CloudsSVG from '@/assets/svg/clouds.svg'
import ServerError from '@/assets/svg/500-bg.svg'

const { isMobile } = useDevicePlatform()

useHead({
  titleTemplate: (title) => `${title} - Server Error`,
})
</script>

<style lang="postcss" scoped>
.bg-image {
  @apply h-screen w-full;
}

.bg-image--desktop {
  @apply object-cover lg:aspect-video lg:h-auto lg:object-fill;
}

.bg-image--mobile {
  @apply object-fill lg:object-contain;
}
</style>
